import React, { useState } from 'react'
import { Box, Image, Skeleton } from '@chakra-ui/react'

export default function OptimizedImage({
  src,
  alt = 'Image',
  w = '100%',
  h = '100%',
  boxSize,
  borderRadius = 'md',
  objectFit = 'cover',
  fallbackSrc = 'https://via.placeholder.com/150?text=No+Image',
  ...props
}) {
  const [isLoaded, setIsLoaded] = useState(false)
  const [hasError, setHasError] = useState(false)

  const finalW = boxSize || w
  const finalH = boxSize || h

  return (
    <Box
      position='relative'
      w={finalW}
      h={finalH}
      borderRadius={borderRadius}
      overflow='hidden'
      flexShrink={0}
      display='inline-flex'
      alignItems='center'
      justifyContent='center'
    >
      {!isLoaded && !hasError && (
        <Skeleton
          position='absolute'
          top={0}
          left={0}
          w='100%'
          h='100%'
          borderRadius={borderRadius}
          startColor='gray.100'
          endColor='gray.300'
          _dark={{ startColor: 'navy.800', endColor: 'navy.700' }}
        />
      )}
      <Image
        src={src}
        alt={alt}
        w={finalW}
        h={finalH}
        borderRadius={borderRadius}
        objectFit={objectFit}
        loading='lazy'
        decoding='async'
        opacity={isLoaded ? 1 : 0}
        transition='opacity 0.25s ease-in-out'
        onLoad={() => setIsLoaded(true)}
        onError={() => {
          setHasError(true)
          setIsLoaded(true)
        }}
        fallbackSrc={fallbackSrc}
        {...props}
      />
    </Box>
  )
}
